import { Box, Collapse, Group } from '@mantine/core';
import cx from 'clsx';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Icon, IconType } from 'src/components/Icon';

import styles from './styles.module.css';

type LinksProps = {
  icon: string;
  label: string;
  opened: boolean;
  link: string;
  links?: { label: string; link: string }[];
};

export const Links = memo(
  ({ icon, label, links, link, opened }: LinksProps) => {
    const { pathname } = useLocation();
    const hasLinks = Array.isArray(links);
    const isActive = hasLinks
      ? links.some((item) => item.link === pathname)
      : !!(link && link === pathname);

    const subItems = (hasLinks ? links : []).map((item) => (
      <NavLink
        to={item.link}
        className={cx({
          [styles.subItem]: true,
          [styles.subItemActive]: item.link === pathname,
        })}
        key={item.label}
      >
        {item.label}
      </NavLink>
    ));

    const contentOpened = (
      <NavLink
        to={link}
        className={cx({
          [styles.mainItem]: true,
          [styles.mainItemActive]: isActive,
        })}
      >
        <Group justify="space-between" className={styles.group}>
          <Box style={{ alignItems: 'center', display: 'flex' }}>
            <Icon className={styles.icon} name={icon as IconType} />
            <Box className={styles.label}>{label}</Box>
          </Box>

          {hasLinks && (
            <Icon
              className={cx({
                [styles.arrowIcon]: true,
                [styles.arrowIconAnimated]: isActive,
              })}
              name="navigationArrow"
            />
          )}
        </Group>
      </NavLink>
    );

    const contentClosed = (
      <NavLink
        to={link}
        className={cx({
          [styles.mainItem]: true,
          [styles.mainItemClosed]: true,
          [styles.mainItemActive]: isActive,
        })}
      >
        <Icon className={styles.icon} name={icon as IconType} />
      </NavLink>
    );

    return (
      <>
        {opened ? contentOpened : contentClosed}
        {hasLinks && opened ? (
          <Collapse in={isActive}>{subItems}</Collapse>
        ) : null}
      </>
    );
  }
);
